// Screen reader announcement and navigation fix for product cards & swatches (Windows Narrator & Keyboard compatible)
(function () {
  let lastAnnounceTime = 0;

  function getOrCreateAnnouncer() {
    let announcer = document.getElementById('sr-card-desc-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'sr-card-desc-announcer';
      announcer.setAttribute('role', 'alert');
      announcer.setAttribute('aria-live', 'assertive');
      announcer.setAttribute('aria-atomic', 'true');
      // Standard W3C visually-hidden CSS pattern recognized by Windows Narrator
      announcer.style.cssText = 'position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;';
      (document.body || document.documentElement).appendChild(announcer);
    }
    return announcer;
  }

  function announceMessage(message) {
    const announcer = getOrCreateAnnouncer();
    announcer.innerHTML = '';
    setTimeout(function () {
      const p = document.createElement('p');
      p.textContent = message;
      announcer.appendChild(p);
    }, 50);
  }

  function isSwatchElement(target) {
    if (!target) return false;
    return !!target.closest(
      '.collection-product-card__swatch, .collection-product-card__variants, .product-form__input--swatch, .swatch-input__label, .swatch, input.swatch-input__input, .pack-swt, .non-pack-swt'
    );
  }

  function getSwatchName(target) {
    if (!target) return '';

    // Structure 1: Card / Collection Swatches (.collection-product-card__swatch)
    const cardSwatchContainer = target.closest('.collection-product-card__swatch');
    if (cardSwatchContainer) {
      const radio = cardSwatchContainer.querySelector('input[type="radio"]');
      if (radio && radio.value) return radio.value.trim();

      const swatchSpan = cardSwatchContainer.querySelector('.swatch[aria-label]');
      if (swatchSpan && swatchSpan.getAttribute('aria-label')) {
        return swatchSpan.getAttribute('aria-label').trim();
      }

      const hiddenText = cardSwatchContainer.querySelector('.visually-hidden');
      if (hiddenText && hiddenText.textContent) return hiddenText.textContent.trim();
    }

    // Structure 2: Product Page / Fieldset Swatches (.product-form__input--swatch, .pack-swt, .swatch-input__label)
    const label = target.closest('label');
    if (label) {
      if (label.getAttribute('title')) return label.getAttribute('title').trim();

      const forId = label.getAttribute('for');
      if (forId) {
        const input = document.getElementById(forId);
        if (input && input.value) return input.value.trim();
      }

      const firstHidden = label.querySelector('.visually-hidden:not(.label-unavailable)');
      if (firstHidden && firstHidden.textContent) return firstHidden.textContent.trim();
    }

    const inputRadio = target.closest('input[type="radio"]');
    if (inputRadio && inputRadio.value) {
      return inputRadio.value.trim();
    }

    const ariaLabelEl = target.closest('[aria-label]');
    if (ariaLabelEl && ariaLabelEl.getAttribute('aria-label')) {
      return ariaLabelEl.getAttribute('aria-label').trim();
    }

    const titleEl = target.closest('[title]');
    if (titleEl && titleEl.getAttribute('title')) {
      return titleEl.getAttribute('title').trim();
    }

    return '';
  }

  function isMediaGalleryElement(target) {
    if (!target) return false;
    return !!target.closest(
      'media-gallery, .thumbnail-list__item, button.thumbnail, .product__media-item, .product__modal-opener, button.product__media-toggle'
    );
  }

  function handleMediaGalleryInteraction(event) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || (event.type === 'click' && event.button !== 0)) {
      return;
    }

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }

    const galleryItem = event.target.closest(
      '.thumbnail-list__item, button.thumbnail, .product__media-item, .product__modal-opener, button.product__media-toggle'
    );
    if (!galleryItem) return;

    const now = Date.now();
    if (now - lastAnnounceTime < 300) return;
    lastAnnounceTime = now;

    let altText = '';
    const img = galleryItem.querySelector('img') || galleryItem.closest('li, div, modal-opener, media-gallery')?.querySelector('img');
    if (img && img.alt) {
      altText = img.alt.split(';@')[0].split('@')[0].trim();
    }
    if (!altText && img && img.getAttribute('aria-label')) {
      altText = img.getAttribute('aria-label').trim();
    }
    if (!altText) {
      const ariaLabel = galleryItem.getAttribute('aria-label') || galleryItem.querySelector('[aria-label]')?.getAttribute('aria-label');
      if (ariaLabel) {
        altText = ariaLabel.replace(/^Load image \d+ in gallery view/i, '').trim();
      }
    }

    if (altText) {
      announceMessage(altText + ' selected');
    }
  }

  function handleInteraction(event) {
    // Ignore modifier key combos (Ctrl+click, Cmd+click, Shift+click, middle click) to preserve new-tab opening
    if (event.ctrlKey || event.metaKey || event.shiftKey || (event.type === 'click' && event.button !== 0)) {
      return;
    }

    // For keydown, process Enter or Space
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }

    // Check if interaction is on Media Gallery (Product Page Gallery Slider / Thumbnails)
    if (isMediaGalleryElement(event.target)) {
      handleMediaGalleryInteraction(event);
      return;
    }

    // Check if interaction is on a Swatch (Structure 1 or Structure 2)
    if (isSwatchElement(event.target)) {
      const now = Date.now();
      if (now - lastAnnounceTime < 300) return;
      lastAnnounceTime = now;

      const swatchName = getSwatchName(event.target);
      if (swatchName) {
        announceMessage(swatchName + 'selected ');
      }

      // If keydown (Enter/Space) on a non-input swatch element, trigger click to select variant
      if (event.type === 'keydown' && event.target.tagName !== 'INPUT') {
        const radioOrLabel = event.target.closest('label') || event.target.querySelector('label') || event.target.closest('.collection-product-card__swatch')?.querySelector('input');
        if (radioOrLabel && typeof radioOrLabel.click === 'function') {
          radioOrLabel.click();
        }
      }
      return;
    }

    // Otherwise, check if interaction is on a Product Card
    if (event.target.closest('.quick-add-modal, button, input, select, label')) {
      return;
    }

    const card = event.target.closest('.card-wrapper, .product-card-wrapper, .card-product-custom-div, .card, [data-product-title]');
    if (!card) return;

    // Prevent duplicate triggers if both keydown and click fire rapidly (Narrator Scan Mode)
    const now = Date.now();
    if (now - lastAnnounceTime < 300) return;
    lastAnnounceTime = now;

    let productName = card.getAttribute('data-product-title');
    if (!productName) {
      const titleContainer = card.closest('[data-product-title]') || card.querySelector('[data-product-title]');
      if (titleContainer) productName = titleContainer.getAttribute('data-product-title');
    }
    if (!productName) {
      const headingEl = card.querySelector('.card__heading, .full-unstyled-link, h3, a');
      if (headingEl) productName = headingEl.textContent.trim();
    }

    if (productName) {
      announceMessage('View details for ' + productName);

      const dataLink = card.getAttribute('data-link') || card.querySelector('a[href]')?.getAttribute('href');
      if (dataLink) {
        event.preventDefault();
        setTimeout(function () {
          window.location.href = dataLink;
        }, 300);
      }
    }
  }

  function handleSortByAnnouncement(event) {
    const select = event.target.closest('select[name="sort_by"], select#SortBy, select#SortBy-mobile, .facet-filters__sort');
    if (!select) return;

    if (event.type === 'keydown' && event.key !== 'Enter' && event.keyCode !== 13) {
      return;
    }

    const now = Date.now();
    if (now - lastAnnounceTime < 300) return;
    lastAnnounceTime = now;

    const selectedOption = select.options[select.selectedIndex];
    if (selectedOption) {
      const optionText = selectedOption.textContent.trim();
      if (optionText) {
        announceMessage(optionText + ' selected');
      }
    }
  }

  function handleBoostSortAnnouncement(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.keyCode !== 13) {
      return;
    }

    if (event.type !== 'keydown' && event.type !== 'click') {
      return;
    }

    const optionButton = event.target.closest('.boost-sd__sorting-option-item');
    if (!optionButton) return;

    const optionText = optionButton.textContent.replace(/\s+/g, ' ').trim();
    if (!optionText) return;

    const scrollPosition = window.scrollY;

    // Boost refreshes and closes the list after selection, so restore focus to its persistent button.
    function restoreBoostSortFocus() {
      const newSorting = document.querySelector('.boost-sd__sorting');
      if (newSorting) {
        const focusTarget = newSorting.querySelector('.boost-sd__sorting-button');
        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
          window.scrollTo(0, scrollPosition);
        }
      }
    }

    restoreBoostSortFocus();
    [50, 150, 300, 600, 1000, 1500].forEach(function (delay) {
      setTimeout(restoreBoostSortFocus, delay);
    });

    const now = Date.now();
    if (now - lastAnnounceTime < 300) return;
    lastAnnounceTime = now;

    announceMessage(optionText + ' selected');
  }

  function enhanceBoostSorting() {
    document.querySelectorAll('.boost-sd__sorting').forEach(function (sorting) {
      const sortingButton = sorting.querySelector('.boost-sd__sorting-button');
      const sortingList = sorting.querySelector('.boost-sd__sorting-list');
      const optionButtons = Array.from(sorting.querySelectorAll('.boost-sd__sorting-option-item'));
      if (!sortingButton || !sortingList || !optionButtons.length) return;

      if (!sortingList.id) sortingList.id = 'boost-sort-list-' + Math.random().toString(36).slice(2);
      sortingButton.setAttribute('role', 'combobox');
      sortingButton.setAttribute('aria-haspopup', 'listbox');
      sortingButton.setAttribute('aria-controls', sortingList.id);
      sortingList.setAttribute('role', 'listbox');

      optionButtons.forEach(function (optionButton, index) {
        const option = optionButton.closest('.boost-sd__sorting-option');
        if (!option) return;

        optionButton.id = option.id || 'boost-sort-option-' + index;
        optionButton.setAttribute('role', 'option');
        optionButton.setAttribute('tabindex', '0');
        optionButton.setAttribute('aria-selected', option.classList.contains('boost-sd__sorting-option--active') ? 'true' : 'false');
        option.removeAttribute('role');
        option.removeAttribute('aria-selected');
      });
    });
  }

  function handleBoostSortArrowKeys(event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Enter') return;

    const sortingButton = event.target.closest('.boost-sd__sorting-button');
    if (!sortingButton) return;

    const sorting = sortingButton.closest('.boost-sd__sorting');
    const options = Array.from(sorting?.querySelectorAll('.boost-sd__sorting-option-item') || []);
    if (!sorting || !options.length || sortingButton.getAttribute('aria-expanded') !== 'true') return;

    const activeId = sortingButton.getAttribute('aria-activedescendant');
    if (event.key === 'Enter' && activeId) {
      const activeOption = options.find(function (option) { return option.id === activeId; });
      if (activeOption) {
        event.preventDefault();
        event.stopImmediatePropagation();
        activeOption.click();
      }
      return;
    }

    let currentIndex = activeId ? options.findIndex(function (option) { return option.id === activeId; }) : options.findIndex(function (option) {
      return option.getAttribute('aria-selected') === 'true';
    });
    if (currentIndex < 0) currentIndex = 0;

    const nextIndex = (currentIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
    const nextOption = options[nextIndex];

    event.preventDefault();
    event.stopImmediatePropagation();
    options.forEach(function (option, index) {
      option.setAttribute('aria-selected', index === nextIndex ? 'true' : 'false');
      option.closest('.boost-sd__sorting-option')?.classList.toggle('boost-sd__sorting-option--active', index === nextIndex);
    });
    sortingButton.setAttribute('aria-activedescendant', nextOption.id);
  }

  // Track Add To Cart and announce mini cart opening + product added
  let pendingAddToCartTitle = '';
  let pendingAddToCartQuantity = '';
  let pendingAddToCartPrice = '';

  function trackAddToCartClick(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }

    const btn = event.target.closest('button[name="add"], .product-form__submit, [id^="ProductSubmitButton"], product-form button[type="submit"]');
    if (!btn) return;

    let title = '';
    let quantity = '';
    let price = '';

    const form = btn.closest('form, product-form, .product-form, .product, .card-wrapper');
    if (form) {
      const titleEl = form.querySelector('.product__title, h1.product__title, h1, .card__heading, [data-product-title]');
      if (titleEl) title = titleEl.textContent.trim();

      const qtyEl = form.querySelector('input[name="quantity"], .quantity__input');
      if (qtyEl && qtyEl.value) quantity = qtyEl.value.trim();

      const priceEl = form.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular, .price-item, .price');
      if (priceEl) price = priceEl.textContent.replace(/\s+/g, ' ').trim();
    }
    if (!title) {
      const mainTitle = document.querySelector('.product__title, h1.product__title, h1');
      if (mainTitle) title = mainTitle.textContent.trim();
    }
    if (!quantity) {
      const mainQty = document.querySelector('input[name="quantity"], .quantity__input');
      if (mainQty && mainQty.value) quantity = mainQty.value.trim();
    }
    if (!price) {
      const mainPrice = document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular, .price-item, .price');
      if (mainPrice) price = mainPrice.textContent.replace(/\s+/g, ' ').trim();
    }

    if (title) {
      pendingAddToCartTitle = title.replace(/\s+/g, ' ').trim();
      pendingAddToCartQuantity = quantity ? quantity.replace(/\s+/g, ' ').trim() : '';
      pendingAddToCartPrice = price ? price.replace(/\s+/g, ' ').trim() : '';
    }
  }

  function announceCartAdded(productTitle, productQuantity, productPrice) {
    const title = productTitle || pendingAddToCartTitle || window.lastAddedProductTitle || '';
    const quantity = productQuantity || pendingAddToCartQuantity || '';
    let price = productPrice || pendingAddToCartPrice || '';

    if (typeof price === 'number') {
      price = '$' + (price / 100).toFixed(2);
    }

    if (title) {
      let extra = '';
      if (quantity) extra += ' quantity ' + quantity;
      if (price) extra += ' price ' + price;

      announceMessage('mini cart has been open as a pop-up ' + title + extra + ' added to the cart');
      pendingAddToCartTitle = '';
      pendingAddToCartQuantity = '';
      pendingAddToCartPrice = '';
      window.lastAddedProductTitle = '';
    }
  }

  // Subscribe to theme cart updates
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      const item = (event?.cartData?.items && event?.cartData?.items[0]) || event?.cartData;
      const title = item?.product_title || item?.title || event?.cartData?.product_title || event?.cartData?.title;
      const quantity = item?.quantity || event?.cartData?.quantity;
      let price = item?.final_price || item?.price || item?.original_price || event?.cartData?.final_price || event?.cartData?.price;
      announceCartAdded(title, quantity, price);
    });
  }

  // Observe cart-drawer active state as fallback
  function initCartDrawerObserver() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (cartDrawer.classList.contains('active') && (pendingAddToCartTitle || window.lastAddedProductTitle)) {
              announceCartAdded();
            }
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true });
    }
  }

  // Pre-create announcer on DOM load so screen readers register the live region before Enter press
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      getOrCreateAnnouncer();
      initCartDrawerObserver();
    });
  } else {
    getOrCreateAnnouncer();
    initCartDrawerObserver();
  }

  // Listen to keydown, change, and click events across cards, title links, swatches, gallery media, sort dropdowns, and add-to-cart buttons
  document.addEventListener('change', handleSortByAnnouncement);
  document.addEventListener('keydown', handleSortByAnnouncement);
  document.addEventListener('keydown', handleBoostSortArrowKeys, true);
  document.addEventListener('keydown', handleBoostSortAnnouncement, true);
  document.addEventListener('click', handleBoostSortAnnouncement, true);
  enhanceBoostSorting();
  new MutationObserver(enhanceBoostSorting).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('keydown', trackAddToCartClick);
  document.addEventListener('click', trackAddToCartClick);
  document.addEventListener('keydown', handleInteraction);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.card-wrapper, .product-card-wrapper, .card-product-custom-div, .card, img[role="link"], .collection-product-card__swatch, .collection-product-card__variants, .product-form__input--swatch, .swatch-input__label, .swatch, media-gallery, .thumbnail-list__item, button.thumbnail, .product__media-item, .product__modal-opener, button.product__media-toggle')) {
      handleInteraction(event);
    }
  });
})();

// Ensure certain boost-sd elements are keyboard-focusable (for third-party injected markup)
(function () {
  function setTabindex() {
    var els = document.querySelectorAll('.boost-sd__breadcrumb-link--no-hover, .boost-sd__header-title, .boost-sd__product-label, .boost-sd__format-currency, .rich-text__text p, .cf-field h2');
    els.forEach(function (el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }

  function fixBoostProductCount() {
    var els = document.querySelectorAll('.boost-sd__product-count, .boost-sd__toolbar-item--product-count, .boost-sd__toolbar-item');
    els.forEach(function (el) {
      ['role', 'aria-live', 'aria-atomic'].forEach(function (attr) {
        if (el.hasAttribute(attr)) {
          el.removeAttribute(attr);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTabindex();
      fixBoostProductCount();
    });
  } else {
    setTabindex();
    fixBoostProductCount();
  }

  var observer = new MutationObserver(function () {
    setTabindex();
    fixBoostProductCount();
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();

// Header Dropdown Menu Keyboard Navigation & Accessibility Fix
(function () {
  function getDropdownName(summary) {
    if (!summary) return '';
    var span = summary.querySelector('span');
    var rawText = span ? span.textContent : summary.textContent;
    return (rawText || '').replace(/\s+/g, ' ').trim();
  }

  function getFocusableElements(container) {
    if (!container) return [];
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var elements = Array.prototype.slice.call(container.querySelectorAll(selector));
    return elements.filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function getNextFocusableElement(currentDetails) {
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var all = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });

    var lastInDetailsIndex = -1;
    for (var i = 0; i < all.length; i++) {
      if (currentDetails.contains(all[i])) {
        lastInDetailsIndex = i;
      }
    }

    if (lastInDetailsIndex !== -1 && lastInDetailsIndex < all.length - 1) {
      return all[lastInDetailsIndex + 1];
    }
    return null;
  }

  // Set aria-expanded and aria-label attributes on header details elements
  function initHeaderMenuAccessibility() {
    var detailsList = document.querySelectorAll('header-menu details, details.mega-menu, details.Details-HeaderMenu');
    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      var isOpen = details.hasAttribute('open');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      var content = details.querySelector('.mega-menu__content, .header__submenu');
      if (content && content.id) {
        summary.setAttribute('aria-controls', content.id);
      }

      var dropdownName = getDropdownName(summary);
      if (dropdownName) {
        summary.setAttribute('aria-label', dropdownName + ' dropdown menu press tab to open');
      }

      // Ensure mega nav images have accessible alt text if focused
      details.querySelectorAll('.mega-nav-image').forEach(function (img) {
        if (!img.getAttribute('alt')) {
          img.setAttribute('alt', dropdownName ? dropdownName + ' featured banner' : 'Featured banner');
        }
      });
    });
  }

  // Handle Tab, Shift+Tab, and Escape key navigation
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.key !== 'Escape' && e.key !== 'Esc') return;

    var active = document.activeElement;
    if (!active) return;

    // Case A: User is on <summary> and presses Tab (Forward)
    if (e.key === 'Tab' && !e.shiftKey) {
      var summary = active.closest('header-menu details summary, details.mega-menu summary, details.Details-HeaderMenu summary');
      if (summary) {
        var details = summary.closest('details');
        if (details) {
          var content = details.querySelector('.mega-menu__content, .header__submenu');
          if (content) {
            var focusables = getFocusableElements(content);
            if (focusables.length > 0) {
              e.preventDefault();
              if (!details.hasAttribute('open')) {
                details.setAttribute('open', '');
                summary.setAttribute('aria-expanded', 'true');
              }
              focusables[0].focus();
              return;
            }
          }
        }
      }
    }

    // Case B: User is INSIDE the dropdown content and presses Tab or Shift+Tab
    var details = active.closest('header-menu details, details.mega-menu, details.Details-HeaderMenu');
    if (details && details.hasAttribute('open')) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.mega-menu__content, .header__submenu');

      if (e.key === 'Escape' || e.key === 'Esc') {
        if (summary) {
          e.preventDefault();
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
          return;
        }
      }

      if (content && content.contains(active)) {
        var focusables = getFocusableElements(content);
        if (focusables.length > 0) {
          var firstItem = focusables[0];
          var lastItem = focusables[focusables.length - 1];

          // Shift + Tab on FIRST dropdown item -> Move focus back to summary
          if (e.shiftKey && e.key === 'Tab' && active === firstItem) {
            e.preventDefault();
            summary.focus();
            return;
          }

          // Tab on LAST dropdown item -> Close dropdown & move focus to NEXT main menu item
          if (!e.shiftKey && e.key === 'Tab' && active === lastItem) {
            e.preventDefault();
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');

            var nextEl = getNextFocusableElement(details);
            if (nextEl) {
              nextEl.focus();
            }
            return;
          }
        }
      }
    }
  });

  // Sync aria-expanded state when details toggle
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (details && details.matches && details.matches('header-menu details, details.mega-menu, details.Details-HeaderMenu')) {
      var summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
      }
    }
  }, true);

  // Initialize on load
  document.addEventListener('DOMContentLoaded', initHeaderMenuAccessibility);
  window.addEventListener('load', initHeaderMenuAccessibility);

  var observer = new MutationObserver(initHeaderMenuAccessibility);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Boost Filter (boost-sd) Product Card Title Screen Reader Announcement Fix
// Announces "View details for + {product name}" when user activates a Boost product title via Enter, Space, or Screen Reader click
(function () {
  var lastBoostAnnounceTime = 0;

  function getOrCreateBoostAnnouncer() {
    var announcer = document.getElementById('sr-card-desc-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'sr-card-desc-announcer';
      announcer.setAttribute('role', 'alert');
      announcer.setAttribute('aria-live', 'assertive');
      announcer.setAttribute('aria-atomic', 'true');
      announcer.style.cssText =
        'position:absolute!important;width:1px!important;height:1px!important;' +
        'padding:0!important;margin:-1px!important;overflow:hidden!important;' +
        'clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;';
      (document.body || document.documentElement).appendChild(announcer);
    }
    return announcer;
  }

  function announceBoostMessage(message) {
    var announcer = getOrCreateBoostAnnouncer();
    announcer.innerHTML = '';
    setTimeout(function () {
      var p = document.createElement('p');
      p.textContent = message;
      announcer.appendChild(p);
    }, 50);
  }

  function getBoostProductName(link, titleEl) {
    if (titleEl && titleEl.textContent) {
      var text = titleEl.textContent.replace(/\s+/g, ' ').trim();
      if (text) return text;
    }

    if (link) {
      var innerTitle = link.querySelector('.boost-sd__product-title');
      if (innerTitle && innerTitle.textContent) {
        var text = innerTitle.textContent.replace(/\s+/g, ' ').trim();
        if (text) return text;
      }

      var card = link.closest('.boost-sd__product-info, .boost-sd__product-info-wrapper, [data-product-card-tracked], .boost-sd__product-item');
      if (card) {
        var cardTitle = card.querySelector('.boost-sd__product-title');
        if (cardTitle && cardTitle.textContent) {
          var text = cardTitle.textContent.replace(/\s+/g, ' ').trim();
          if (text) return text;
        }
      }

      var ariaLabel = link.getAttribute('aria-label');
      if (ariaLabel) {
        var cleanLabel = ariaLabel.replace(/^View details for\s+/i, '').replace(/\s+/g, ' ').trim();
        if (cleanLabel) return cleanLabel;
      }

      var linkText = link.textContent.replace(/\s+/g, ' ').trim();
      if (linkText) return linkText;
    }

    return '';
  }

  function handleBoostProductTitle(event) {
    // Ignore modifier keys to allow normal new-tab behaviors
    if (event.ctrlKey || event.metaKey || event.shiftKey || (event.type === 'click' && event.button !== 0)) {
      return;
    }

    // For keydown, only trigger on Enter or Space
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }

    // Ignore swatches, inputs, and buttons
    if (event.target.closest('.boost-sd__product-swatch, .boost-sd__radio, input, select, button, label')) {
      return;
    }

    var titleEl = event.target.closest('.boost-sd__product-title');
    var link = event.target.closest('a.boost-sd__product-link, a[class*="boost-sd__product"]');

    if (!link && titleEl) {
      link = titleEl.closest('a');
    }

    if (!link) {
      var cardInfo = event.target.closest('.boost-sd__product-info, .boost-sd__product-info-wrapper, [data-product-card-tracked]');
      if (cardInfo && titleEl) {
        link = cardInfo.querySelector('a.boost-sd__product-link, a[href*="/products/"]');
      }
    }

    if (!link) return;

    var destinationUrl = link.getAttribute('href') || link.href;
    if (!destinationUrl) return;

    // Prevent duplicate triggers if both keydown and synthetic click fire
    var now = Date.now();
    if (now - lastBoostAnnounceTime < 400) return;
    lastBoostAnnounceTime = now;

    var productName = getBoostProductName(link, titleEl);
    if (!productName) return;

    // Stop immediate navigation and other click handlers so speech can begin
    event.preventDefault();
    event.stopPropagation();

    announceBoostMessage('View details for ' + productName);

    setTimeout(function () {
      window.location.href = destinationUrl;
    }, 650);
  }

  function getBoostSwatchName(target) {
    if (!target) return '';

    var label = target.closest('.boost-sd__radio-label, label');
    if (label) {
      var forId = label.getAttribute('for');
      if (forId) {
        var input = document.getElementById(forId);
        if (input && input.value) return input.value.trim();
      }

      var text = label.textContent.replace(/\s+/g, ' ').trim();
      if (text) return text;

      var ariaLabel = label.getAttribute('aria-label');
      if (ariaLabel) {
        return ariaLabel.replace(/^color:\s*/i, '').trim();
      }
    }

    var option = target.closest('.boost-sd__product-swatch-option, .boost-sd__radio');
    if (option) {
      var radio = option.querySelector('input[type="radio"]');
      if (radio && radio.value) return radio.value.trim();

      var tooltip = option.querySelector('.boost-sd__tooltip-content');
      if (tooltip && tooltip.textContent) return tooltip.textContent.replace(/\s+/g, ' ').trim();
    }

    return '';
  }

  function handleBoostSwatch(event) {
    // Ignore modifier keys
    if (event.ctrlKey || event.metaKey || event.shiftKey || (event.type === 'click' && event.button !== 0)) {
      return;
    }

    // Only handle Enter or Space on keydown
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ' && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }

    var swatchEl = event.target.closest(
      '.boost-sd__product-swatch-option, .boost-sd__radio, .boost-sd__radio-label, .boost-sd__radio-input'
    );
    if (!swatchEl) return;

    var swatchName = getBoostSwatchName(swatchEl);
    if (!swatchName) return;

    // Prevent duplicate triggers if both keydown and synthetic click fire
    var now = Date.now();
    if (now - lastBoostAnnounceTime < 300) return;
    lastBoostAnnounceTime = now;

    announceBoostMessage(swatchName + ' selected');

    // On keydown (Enter/Space) on a non-input element, trigger click to activate variant
    if (event.type === 'keydown' && event.target.tagName !== 'INPUT') {
      var clickable = swatchEl.closest('.boost-sd__radio')?.querySelector('label') || swatchEl;
      if (clickable && typeof clickable.click === 'function') {
        clickable.click();
      }
    }
  }

  // Pre-create announcer on load so screen readers register it in the accessibility tree early
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      getOrCreateBoostAnnouncer();
    });
  } else {
    getOrCreateBoostAnnouncer();
  }

  // Handle Back-Forward Cache (BFCache) and history navigation:
  // Clean announcer text on return and exit, keeping the DOM node intact so screen readers don't lose the live-region
  function cleanAnnouncerState() {
    lastBoostAnnounceTime = 0;
    var announcer = document.getElementById('sr-card-desc-announcer');
    if (announcer) {
      announcer.innerHTML = '';
    }
  }

  window.addEventListener('pageshow', cleanAnnouncerState);
  window.addEventListener('popstate', cleanAnnouncerState);
  window.addEventListener('pagehide', cleanAnnouncerState);

  // Intercept both keydown (regular keyboard / non-scan mode) and click (NVDA browse mode / Narrator scan mode)
  document.addEventListener('keydown', function (event) {
    handleBoostSwatch(event);
    handleBoostProductTitle(event);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.boost-sd__product-swatch, .boost-sd__product-swatch-option, .boost-sd__radio, .boost-sd__radio-label')) {
      handleBoostSwatch(event);
    }
    if (event.target.closest('.boost-sd__product-link, .boost-sd__product-title, a[class*="boost-sd__product"]')) {
      handleBoostProductTitle(event);
    }
  }, true);
})();

